import type { InputHTMLAttributes, Ref } from "react";
import s from "./Input.module.css";

/** React 19: ref is a plain prop, no forwardRef needed. */
export function Input({
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & { ref?: Ref<HTMLInputElement> }) {
  return <input className={[s.input, className ?? ""].join(" ")} {...rest} />;
}
